import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ValidationConstants } from '@app/core/constants/validation.constants';

export class DxcFormValidators {
  static npi = DxcFormValidators.regex(ValidationConstants.npiRegex, 'npi');
  static taxId = DxcFormValidators.regex(ValidationConstants.taxIdRegex, 'taxId');
  static date = (control: AbstractControl): ValidationErrors | null => {
    const errorName = 'date';
    const errors = control.errors ?? {};

    if (!control.value) {
      delete errors[errorName];
      return errors;
    }

    if (!(control.value instanceof Date) && !ValidationConstants.isoDateRegex.test(control.value)) {
      return { [errorName]: true };
    }

    return null;
  };

  static minDate(date: Date) {
    return (control: AbstractControl): ValidationErrors | null => {
      const errors = control.errors ?? {};
      const errorName = 'minDate';

      if (!control.value) {
        delete errors[errorName];
        return errors;
      }

      const value = new Date(control.value);

      if (value < date) {
        return { [errorName]: true };
      }

      return null;
    };
  }

  static maxDate(date: Date) {
    return (control: AbstractControl): ValidationErrors | null => {
      const errors = control.errors ?? {};
      const errorName = 'minDate';

      if (!control.value) {
        delete errors[errorName];
        return errors;
      }

      const value = new Date(control.value);

      if (value > date) {
        return { [errorName]: true };
      }

      return null;
    };
  }

  static regex(regex: RegExp, errorName: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const errors = control.errors ?? {};

      if (!control.value) {
        delete errors[errorName];
        return errors;
      }

      const value = control.value as string;

      if (!regex.test(value)) {
        return { [errorName]: true };
      }

      return null;
    };
  }
}
